<script>
export default {
	name: "DisabledStylableTextarea",
	props: {
		value: { type: String, required: false, default: "" },
		placeholder: { type: String, required: false, default: "" },
		alignCenter: { type: Boolean, required: false, default: true },
		pointer: { type: Boolean, required: false, default: true }
	},
	computed: {
		valueLength() {
			return this.value ? this.value.replace(/<p>\s*(<br[^>]*>)?\s*<\/p>/g, "").trim().length : 0;
		},
		inactiveValue() {
			return this.value ? this.addPragraphToBr(this.addBrToEmptyParagraphs(this.value)) : "";
		}
	},
	methods: {
		addBrToEmptyParagraphs(text) {
			return text ? text.replace(/<p>\s*<\/p>/gi, "<p><br></p>") : "";
		},
		addPragraphToBr(text) {
			return text ? text.split("\n").map(line => line.replace(/^<br>$/i, "<p><br></p>")).join("\n") : "";
		},
		onClick(event) {
			this.$emit("click", event);
		}
	}
};
</script>

<template>
	<div
		@click="onClick"
		:class="['stylable-textarea', {'center': alignCenter}, {'pointer': pointer}]"
	>
		<div>
			<template v-if="valueLength">
				<div v-html="inactiveValue"></div>
			</template>
			<span v-else class="placeholderText">{{ placeholder }}</span>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.stylable-textarea {
	position: relative;
	hyphens: auto;
	white-space: normal;
	text-justify: inter-word;
	cursor: text;
	text-align: justify;

	&.center {
		text-align: center;
	}

	&.pointer {
		cursor: pointer !important;
	}
}

.placeholderText {
	color: rgba(0, 0, 0, 0.6);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
	display: block;
}

:deep(p) {
	margin: 0 !important;
}
</style>
